export default "__VITE_ASSET__2ccc7ef5__"